export default __webpack_public_path__ + "static/media/icon-targeted-distribution.0bd1415c.svg";